import { createContext } from 'react';
export var ComponentDependencyContext = /*#__PURE__*/createContext({});
export var ComponentDependencyProvider = ComponentDependencyContext.Provider;
export var ComponentDependencyConsumer = ComponentDependencyContext.Consumer;